import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

export default function WaitApprovalPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // location.state에서 정보 가져오기 (회원가입 직후)
  // 또는 로그인한 사용자의 경우 user에서 가져오기
  const memberId = location.state?.memberId || user?.memberId;
  const nickname = location.state?.nickname || user?.memberNickname;

  // 회원가입 정보도 없고 로그인도 안 되어 있으면 로그인 페이지로
  useEffect(() => {
    if (!memberId || !nickname) {
      navigate('/login', { replace: true });
    }
  }, [memberId, nickname, navigate]);

  if (!memberId || !nickname) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-yellow-100 p-3">
              <Clock className="w-12 h-12 text-yellow-600" />
            </div>
          </div>
          <CardTitle className="text-2xl">관리자 승인 대기 중</CardTitle>
          <CardDescription>
            회원가입이 완료되었습니다
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="bg-accent/20 border border-accent rounded-lg p-4 space-y-2">
            <div className="flex justify-between">
              <span className="text-sm font-medium text-muted-foreground">아이디</span>
              <span className="text-sm font-semibold">{memberId}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-medium text-muted-foreground">닉네임</span>
              <span className="text-sm font-semibold">{nickname}</span>
            </div>
          </div>

          <div className="space-y-2 text-sm text-muted-foreground">
            <p className="font-medium text-foreground">안내사항</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>관리자의 승인 완료 후 로그인할 수 있습니다</li>
              <li>승인은 보통 24시간 이내에 처리됩니다</li>
            </ul>
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-950/30 border border-yellow-200 dark:border-yellow-900/50 rounded-lg p-3">
            <p className="text-sm text-yellow-800 dark:text-yellow-200">
              💡 승인 완료 전에는 로그인이 불가능합니다
            </p>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col gap-2">
          <Button
            variant="outline"
            className="w-full"
            onClick={() => {
              logout();
              navigate('/login', { replace: true });
            }}
          >
            로그인 페이지로 이동
          </Button>

          <div className="text-xs text-center text-muted-foreground space-y-1">
            <p>문의사항이 있으시면 관리자에게 연락해주세요</p>
            <p className="font-medium text-foreground">관리자: 숲쇽의슛샤슘</p>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
